module.exports = __webpack_public_path__ + "img/p65-shijiazhuang-2016.cfff3ab7.jpg";